"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import classNames from "classnames";
import React from "react";
import { Observer, observer } from "mobx-react";
import { Tick } from "../../../icons";
import { DropdownContext } from "../Dropdown/DropdownContext";
import { DropdownTheme } from "../Dropdown/DropdownTheme";
let DropdownItem = class extends React.Component {
  render() {
    const { name, selected, onSelect, disable } = this.props;
    return /* @__PURE__ */ React.createElement(DropdownContext.Consumer, null, ({ theme }) => /* @__PURE__ */ React.createElement(Observer, null, () => /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames({
          "dropdown-item": true,
          "space-between": true,
          "dropdown-item--disable": disable,
          "dropdown-item--dark": theme === DropdownTheme.Dark
        }),
        onClick: onSelect
      },
      /* @__PURE__ */ React.createElement(
        "span",
        {
          className: classNames({
            "dropdown-item__name": true,
            "dropdown-item__name--disable": disable
          })
        },
        name
      ),
      selected && /* @__PURE__ */ React.createElement(
        Tick,
        {
          className: classNames({
            "dropdown-item__tick": true,
            "dropdown-item__tick--disable": disable
          })
        }
      )
    )));
  }
};
DropdownItem = __decorateClass([
  observer
], DropdownItem);
export {
  DropdownItem as default
};
